import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataScopesEnum } from '../../shared/enums/index';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICustomer, IIngestedDevicesChart, IPermission } from '../../shared/models/index';
import { AuthorizationService, StorageManagerService } from '../../shared/services/index';
import { SubmittedDevicesChartComponent } from '../submitted-devices-chart/submitted-devices-chart.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.Emulated
})

export class DashboardComponent implements OnInit {

  subscription: Subscription;
  permissions: any;
  ingestedDevicesData: IIngestedDevicesChart[] = [];
  submittedDevicesData: SubmittedDevicesChartComponent[] = [];

  @Input() customer: ICustomer;
  @Input() user: any;

  localTime: any;
  userTimeZone: any;

  dataScope: any;

  customersWithTemplates: any[] = [];
  localCustomers: any[] = [];

  constructor (private authorizationService: AuthorizationService, private storageManagerService: StorageManagerService, private appGlobals: AppGlobals) { }

  getTimeZone() {

    this.localTime = new Date().getTimezoneOffset();
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
    // or

    let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
  }

  ngOnInit() {


    this.dataScope = DataScopesEnum;
    this.permissions = this.appGlobals.permissions;

    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();

  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  showDocs(permission) {

    return this.authorizationService.hasPermissionPerClient(permission);
  }

  showPageContents(): boolean {

    let retVal = false;

    const permissions: IPermission[] = this.storageManagerService.read('accessPermissions');

    retVal = !!permissions;

    return retVal;
  }

  // Filtering out the customers that don't have templates so the headers don't print
  filterCustomersWithNoTemplates() {

    // Pulling in the customer data from the storage manager
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');
    if (currentCustomerStr) {
      this.customer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
    }
    this.localCustomers = this.customer.applicationVariants;
    const noTemplatesAvailable = ["australia-udi", "saudiarabia-udi"];

    this.customersWithTemplates = (this.localCustomers as any).filter(x => !(noTemplatesAvailable as any).includes(x['applicationVariantName'].toLowerCase()));

    return (this.customersWithTemplates);

  }
}
